var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer",staticStyle:{"display":"flex !important","align-items":"center !important","height":"52px","padding":"0px !important","padding-right":"10px !important"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }